<template>
    <div>
        <el-card class="box-card">
            <div class="el-card-button">
                <el-button type="primary" size="small" @click="add">添加搜索</el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="title"
                        :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100':''"
                        label="名称">
                </el-table-column>
                <el-table-column
                        :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'150':'280'"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="small" @click="edit(scope.$index)">编辑</el-button>
                        <el-button type="danger" plain size="small" @click="getareaDelete(scope.$index)">删除</el-button>
                    </template>

                </el-table-column>
            </el-table>
        </el-card>
        <!--        添加区域对话框-->
        <el-dialog
                title="添加区域"
                :visible.sync="dialogVisible"
                :width="this.$store.state.dialogWidth">
            <el-form ref="loginForm" status-icon :model="form" :label-width="this.$store.state.labelWidth" size="small">
                <!--                <el-form-item label="名称" prop="name">-->
                <!--                    <el-input v-model="form.name"></el-input>-->
                <!--                </el-form-item>-->
                <el-form-item label="小说">
                    <el-autocomplete
                            class="inline-input"
                            style="width: 100%"
                            v-model="form.name"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入小说名"
                            @select="handleSelect"
                    ></el-autocomplete>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="ReleaseClick" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Comic_Classification",
        data() {
            return {
                form: {
                    name: '',
                },
                classUpdate: {},
                dialogVisible: false, //添加区域对话框
                tableData: [],
                list: [],
                index: '',
            }
        },
        created() {
            this.getclassList();
            this.loadAll();
        },
        methods: {
            getclassList() {
                this.$axios.post("admin/config/hot_keywords",).then(res => {
                    let obj = res.data;
                    let arr = [];
                    this.list = [];
                    for (let key  in obj) {
                        arr.push({title: obj[key]});
                        this.list.push(obj[key])
                    }
                    this.tableData = arr;
                })
            },
            add() {
                this.index = '';
                this.dialogVisible = true;
                this.form.name = '';
            },
            edit(index) {
                this.form.name = this.tableData[index].title;
                this.index = index;
                this.dialogVisible = true;
            },
            // 删除
            getareaDelete(index) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.list.splice(index, 1);
                    this.$axios.post("admin/config/hot_keywords_set", {config: this.list})
                        .then(res => {
                            this.$message.success('删除成功!');
                            this.getclassList()
                        })
                }).catch(() => {
                    this.$message.info('已取消删除');
                });

            },
            // 确定按钮
            ReleaseClick() {
                // 编辑
                if (this.index !== '') {
                    this.list[this.index] = this.form.name;
                    this.$refs.loginForm.validate(e => {
                        this.$axios.post("admin/config/hot_keywords_set", {config: this.list})
                            .then(res => {
                                this.$message.success('修改成功');
                                this.dialogVisible = false;
                                this.getclassList()
                            })
                    })
                } else {
                    // 新增
                    this.list.push(this.form.name);
                    this.$refs.loginForm.validate(e => {
                        this.$axios.post("admin/config/hot_keywords_set", {config: this.list})
                            .then(res => {
                                this.$message.success('添加成功');
                                this.dialogVisible = false;
                                this.getclassList()
                            })
                    })
                }
            },
            loadAll() {
                this.$axios.post("admin/novel/getAll", '').then((res) => {
                    this.restaurants = res.data;
                    this.restaurants.map((num) => {
                        num.value = num.title;
                    })
                });
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                // this.form.anid = item.id;
            },
        }
    }
</script>

<style scoped>

</style>